import Toolbar from "../containers/Header/Toolbar/Toolbar";

import Footer from "../containers/Footer/Footer";
import { useEffect, useState, useMemo } from "react";
import "./page.css";
import axios from "../utils/axiosInstance";
import FeaturedCategories from "../components/category/FeaturedCategories";
import ProductList from "../components/product/ProductList";
import { useNavigate, useParams } from "react-router-dom";
import useDynamicTabTitle from "../useDynamicTabTitle";
import FilterSidebar from "../components/filter/FilterSidebar";
import SelectBox from "../components/edittext/selectbox/SelectBox";

const BrandPage = () => {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const { brandId } = useParams();
  const [brandName, setBrandName] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [finalproduct, setProduct] = useState([]);
  const [sort, setSort] = useState();
  const navigate = useNavigate();
  useDynamicTabTitle(brandName ? `Buy ${brandName} Products?` : "Loading...");
  const fetchData = async () => {
    try {
      setLoading(true);
      const [categoryRes, brandsRes, brandRes] = await Promise.all([
        axios.get("/categories/root"),
        axios.get("/brands?limit=9"),
        axios.get(`/brands/${brandId}`),
      ]);

      setCategories(categoryRes.data.rootCategories);
      setBrands(brandsRes.data.data);
      setBrandName(brandRes.data.data.name);
    } catch (err) {
      console.error("❌ Error loading data:", err);
      setError("Error Loading data!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    applyFilters([brandId]);
  }, []);

  const sortArr = [
    "Most Expensive",
    "Most Cheap",
    "Most Relevant",
    "Newest",
    "Most Sell",
    "Most popular",
  ];
  //   const handleSelectCategory = (cat) => {
  //     navigate(`/category/${cat._id}`);
  //   };
  const applyFilters = async (brandId) => {
    try {
      const res = await axios.get("/products", {
        params: {
          brand: brandId,
        },
      });
      console.log("Filtered Products:", brandId);
      setProduct(res.data.products);
    } catch (err) {
      console.error("Filter error:", err);
      console.log("Filtered Products:", brandId);
    }
  };
  useEffect(() => {
    if (finalproduct) {
      setProduct(finalproduct);
    } else {
      // اگر محصول null بود (حالت افزودن)، مقادیر رو ریست کن
      setProduct([]);
    }
  }, [finalproduct]);
  //   useEffect(() => {
  //     if (!categoryId) return;

  //     axios
  //       .get(`/categories/${categoryId}/path`)
  //       .then((res) => {
  //         setBreadcrumbs(res.data); // انتظار داریم که آرایه‌ای از دسته‌های پدر تا دسته فعلی باشه
  //         setProduct(products);
  //       })
  //       .catch((err) => {
  //         console.error("خطا در دریافت breadcrumb:", err);
  //       });
  //   }, [categoryId]);
  const sortedProducts = useMemo(() => {
    if (!finalproduct) return [];

    let sorted = [...finalproduct];

    switch (sort) {
      case "Most Expensive":
        sorted.sort((a, b) => b.price - a.price);
        break;
      case "Most Cheap":
        sorted.sort((a, b) => a.price - b.price);
        break;
      case "Newest":
        sorted.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        break;
      case "Most Sell":
        sorted.sort((a, b) => b.salesCount - a.salesCount);
        break;
      case "Most popular":
        sorted.sort((a, b) => b.rating - a.rating);
        break;
      default: // Most Relevant
        // اینجا می‌تونی لاجیک مرتبط بودن رو بعداً تعریف کنی
        break;
    }
    return sorted;
  }, [sort, finalproduct]);

  const handleSelectCategory = (cat) => {
    window.location.href = `/category/${cat._id}`;
  };

  if (loading) return <div className="p-3">⏳Loading...</div>;
  if (error) return <div className="p-3 text-danger">{error}</div>;
  return (
    <>
      <Toolbar />

      <div className="container-fluid px-3 py-3">
        {/* Breadcrumb */}
        <nav aria-label="breadcrumb" className="mb-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/">Home</a>
            </li>
            {breadcrumbs.map((item, index) => (
              <li
                key={item._id}
                className={`breadcrumb-item ${
                  index === breadcrumbs.length - 1 ? "active" : ""
                }`}
                aria-current={
                  index === breadcrumbs.length - 1 ? "page" : undefined
                }
              >
                {index === breadcrumbs.length - 1 ? (
                  item.name
                ) : (
                  <a href={`/category/${item._id}`}>{item.name}</a>
                )}
              </li>
            ))}
          </ol>
        </nav>

        {/* عنوان دسته */}
        <h3 className="m-4">{brandName}'s Products</h3>

        {/* لیست محصولات به صورت کارت */}
        {categories.length > 0 && (
          <div className="d-flex mb-3 flex-column align-items-md-center">
            <FeaturedCategories
              categories={categories}
              onSelect={handleSelectCategory}
            />
          </div>
        )}

        <div className="row ">
          {/* Sidebar دسکتاپ */}
          <div className="col-lg-3 d-none d-lg-block order-lg-0">
            <FilterSidebar brands={brands} applyFilters={applyFilters} />
          </div>
          <div className="col-12 col-lg-9 order-lg-1 pe-4">
            {/* دکمه + پنل کشویی برای موبایل */}

            <div class="container mt-4">
              <div class="d-flex justify-content-between align-items-center mb-3 ">
                <div className="d-lg-none mb-0 ">
                  <FilterSidebar brands={brands} applyFilters={applyFilters} />
                </div>
                <ul className="list-inline d-none d-lg-flex mb-0">
                  {sortArr.map((item, index) => (
                    <li key={index} className="list-inline-item">
                      <button
                        onClick={() => setSort(item)}
                        className={`btn btn-sm rounded-pill mx-1 ${
                          sort === item
                            ? "btn-primary text-white"
                            : "btn-outline-secondary"
                        }`}
                      >
                        {item}
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="col-6 col-md-3 ps-5">
                  <SelectBox
                    value={sort}
                    onChange={setSort}
                    array={sortArr}
                    text="Sort"
                    bcolor="primary"
                    textcolor="dark"
                    bgcolor="white"
                    padding="0"
                    margin="0"
                    className="d-lg-none"
                  />
                </div>
              </div>
              <hr className="mb-3" />
            </div>
            <ProductList products={sortedProducts} />
          </div>

          {/* محصولات */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BrandPage;
